var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15.2319H6.75V16.8315H1.5C0.6675 16.8315 0 16.1197 0 15.2319V2.43462C0 1.55481 0.6675 0.834961 1.5 0.834961H10.5C11.3325 0.834961 12 1.55481 12 2.43462V9.26515L10.875 8.60929L10.5 8.83324V2.43462H6.75V8.83324L4.875 7.03363L3 8.83324V2.43462H1.5V15.2319ZM15 12.8324L10.875 10.4329L6.75 12.8324L10.875 15.2319L15 12.8324ZM8.25 14.504V16.1037L10.875 17.6314L13.5 16.1037V14.504L10.875 16.0317L8.25 14.504Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificates);
export default __webpack_public_path__ + "static/media/certificates.c98314bf.svg";
export { ForwardRef as ReactComponent };